import { render } from "./deptManualPoItem.vue?vue&type=template&id=152a7f18"
import script from "./deptManualPoItem.vue?vue&type=script&lang=js"
export * from "./deptManualPoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__